export default function BlogContent({ sections }) {
  return (
    <div className="prose-legal space-y-6 text-base leading-relaxed text-brand-muted">
      {sections.map((block, i) => {
        if (block.type === "h2") {
          return (
            <h2 key={i} className="pt-2 font-display text-2xl font-bold text-brand-ink">
              {block.text}
            </h2>
          );
        }
        if (block.type === "h3") {
          return (
            <h3 key={i} className="font-display text-xl font-bold text-brand-ink">
              {block.text}
            </h3>
          );
        }
        if (block.type === "p") {
          return <p key={i}>{block.text}</p>;
        }
        if (block.type === "ul") {
          return (
            <ul key={i} className="list-disc space-y-2 pl-5">
              {block.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          );
        }
        return null;
      })}
    </div>
  );
}
